import axios from 'axios';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import { config, TOKEN_KEY } from '../constants';
import { msalInstance } from './AuthService';

declare module 'axios' {
  export interface AxiosResponse<T> extends Promise<T> {}
}

export const client = axios.create({
  baseURL: config.url.API_URL,
});

client.interceptors.request.use(
  async config => {
    const token = Cookies.get(TOKEN_KEY);
    if (!token) {
      // If a token was manually removed or if a logout occurred from another tab, enforce logout for any incoming requests.
      await msalInstance.loginRedirect();
    }
    config.headers.Authorization = token;
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

client.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    if (error.response.status === 401) {
      localStorage.clear();
      Cookies.remove(TOKEN_KEY);
      await msalInstance.loginRedirect();
      return;
    }

    if (error.response.status === 500) {
      toast.error(
        'Unable to load resources.\n  Please, check your internet connection and make sure that DA VPN is connected (without Proxy)'
      );
    }

    return Promise.reject(error);
  }
);
